import { MultiSelect } from "primereact/multiselect"
import { useUsers } from "../api/queries/useUsers"

export default function UserMultiFilter(props) {
  const { data: users = [] } = useUsers()

  return (
    <MultiSelect
      showClear={true}
      filter={true}
      options={users}
      optionLabel={"name"}
      optionValue={"uuid"}
      selectedItemsLabel={"{0} záznamů vybráno"}
      value={props.value}
      placeholder={props.placeholder}
      onChange={props.onChange}
    />
  )
}
